import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Icon, useTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IPrimaryNavInterface } from '../../../_const/navigation.const';
import { sidebarStyles } from '../../../_styles/sidebar.styles';

export default function ExpandableList(params: {
    label: string,
    icon: any,
    items: IPrimaryNavInterface[],
    selectedItem: any,
    setSelectedItem: any
}) {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleClick = (item: any) => {
        navigate(item.url);
        params.setSelectedItem && params.setSelectedItem(item);
    };

    const theme = useTheme();
    const brandPrimary = theme.palette.primary.main;

    return (
        <List sx={{ width: '100%', paddingTop: 0, maxWidth: 360 }} component="nav" aria-labelledby="nested-list-subheader">
            <ListItemButton sx={{ marginTop: 0, paddingTop: 0 }} onClick={() => setOpen(!open)}>
                <ListItemIcon>
                    {params.icon || <Icon>settings</Icon>}
                </ListItemIcon>
                <ListItemText primary={params.label} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div">
                    {params.items?.map((item: any) => (
                        <ListItemButton
                            key={item.name}
                            sx={params.selectedItem === item ? {
                                backgroundColor: brandPrimary,
                                color: '#fff',
                                pl: 4,
                                marginLeft: '26px',
                                paddingLeft: '12px',
                                borderLeft: '1px solid grey',
                                "&:hover": {
                                    backgroundColor: brandPrimary,
                                    opacity: 0.7,
                                }
                            } : sidebarStyles.regularItem}
                            onClick={() => handleClick(item)}
                        >
                            <ListItemIcon>
                                <Icon
                                    fontSize="small"
                                    sx={params.selectedItem === item ? { color: '#fff' } : { color: 'disabled' }}
                                >
                                    {item.icon}
                                </Icon>
                            </ListItemIcon>
                            <ListItemText
                                primary={item.name}
                                slotProps={{
                                    primary: { sx: { fontSize: '14px' } }
                                }}
                            />
                        </ListItemButton>
                    ))}
                </List>
            </Collapse>
        </List>
    );
}
